import yieldImage from '../assets/images/yield1.png'
import corner from '../assets/images/corner.png'
import { motion } from "framer-motion";

const MaxYield = () => {

    const animation = (delay, xStart, xEnd, yStart, yEnd) => {
        const result = {
            initial: { opacity: 0, y: 50 },
            whileInView: { opacity: 1, y: 0 },
            viewport: { once: true },
            transition: {
                ease: "easeInOut",
                duration: 0.6,
                delay: delay,
            }
        }
        return result;
    }

    return (
        <>
            <div className="bg-[#091417]" style={{ marginTop: '150px'}}>
                <div className="px-[5%]">
                    <div className="flex flex-row justify-around py-[150px] items-center sm:flex-col">
                        <motion.img 
                            {...animation(0.4)} 
                            src={yieldImage} 
                            className="w-[550px] sm:w-[90%] sm:mb-10"
                        />
                        <motion.div 
                            {...animation(0.6)}
                            className="text-left sm:text-center sm:w-[90%]"
                        > 
                            <div className='text-8xl uppercase font-bold mb-10 sm:text-5xl sm:mb-6'>
                                optimize <br /> your assets
                            </div>
                            <div className='desc'>
                                Discover a cutting-edge platform on Abstract, <br className="sm:hidden" /> 
                                designed for optimal asset management.
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>

            {/* <div className="bg-[#334756] w-1/2 flex h-80   pb-10 corner_bottom -mb-[2px]"></div> */}
        </>
    );
};
export default MaxYield;
